var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-dependency-injection";
import { customAttribute } from "aurelia-framework";
import { BindingEngine } from "aurelia-binding";
var ReadonlyWorflowActivity = /** @class */ (function () {
    function ReadonlyWorflowActivity(element, bindingEngine) {
        this.element = element;
        this.bindingEngine = bindingEngine;
        this.skip = "skip-disable-everything";
        this.readOnlyControlNames = [
            "text-box",
            "text-area",
            "lookup-control",
            "lookup-hierarchy-control",
            "combo-box",
            "check-box",
            "radio-button",
            "date-picker",
            "activity-logger",
            "field",
            "file-uploader",
        ];
        this.removedControlNames = [
            "entity-finder-search",
            ".entity-delete",
            ".partial-entity-attachment-manager .attachment-add",
            ".partial-entity-attachment-manager .attachment-delete",
            ".partial-entity-attachment-manager .attachment-edit",
            "data-grid i.edit",
            "data-grid i.delete"
        ];
        this.disabledControlNames = [
            "custom-button",
            "button-multi-selector"
        ];
    }
    ReadonlyWorflowActivity.prototype.valueChanged = function (newValue, oldValue) {
        this.bind();
    };
    ReadonlyWorflowActivity.prototype.bind = function () {
        var _this = this;
        if (this.element["au"] && this.element["au"].compose) {
            var controller = this.element["au"].compose;
            var compose = controller.viewModel;
            if (compose['currentController']) {
                setTimeout(function () {
                    _this.applyReadonlyAttribute(_this.element, _this.value);
                });
            }
            else {
                var subscription_1 = this.bindingEngine.propertyObserver(compose, 'currentController').subscribe(function (x) {
                    if (x) {
                        setTimeout(function () {
                            _this.applyReadonlyAttribute(_this.element, _this.value);
                            subscription_1.dispose();
                            subscription_1 = null;
                        });
                    }
                });
            }
        }
        else {
            setTimeout(function () {
                _this.applyReadonlyAttribute(_this.element, _this.value);
            });
        }
    };
    ReadonlyWorflowActivity.prototype.applyReadonlyAttribute = function (element, readonly) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e, e_6, _f;
        try {
            // loop in custom control names and find them in the current widget
            for (var _g = __values(this.readOnlyControlNames), _h = _g.next(); !_h.done; _h = _g.next()) {
                var item = _h.value;
                try {
                    for (var _j = (e_2 = void 0, __values($(element).find(item).toArray())), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var control = _k.value;
                        if (control) {
                            // make it readonly
                            if (control.au && !$(control).hasClass(this.skip)) {
                                // if never set
                                control.au.controller.viewModel.readonly = readonly;
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            // loop in custom control names and find them in the current widget
            for (var _l = __values(this.disabledControlNames), _m = _l.next(); !_m.done; _m = _l.next()) {
                var item = _m.value;
                try {
                    for (var _o = (e_4 = void 0, __values($(element).find(item).toArray())), _p = _o.next(); !_p.done; _p = _o.next()) {
                        var control = _p.value;
                        if (control) {
                            // make it readonly
                            if (control.au && !$(control).hasClass(this.skip)) {
                                // if never set
                                control.au.controller.viewModel.disabled = readonly;
                            }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_p && !_p.done && (_d = _o.return)) _d.call(_o);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
            }
            finally { if (e_3) throw e_3.error; }
        }
        try {
            // remove all buttons and make it readonly
            for (var _q = __values(this.removedControlNames), _r = _q.next(); !_r.done; _r = _q.next()) {
                var item = _r.value;
                try {
                    for (var _s = (e_6 = void 0, __values($(element).find(item).toArray())), _t = _s.next(); !_t.done; _t = _s.next()) {
                        var control = _t.value;
                        if (control && !$(control).hasClass(this.skip)) {
                            // remove control
                            if (readonly)
                                $(control).addClass("display-none-imp");
                            else
                                $(control).removeClass("display-none-imp");
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_t && !_t.done && (_f = _s.return)) _f.call(_s);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_e = _q.return)) _e.call(_q);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    ReadonlyWorflowActivity = __decorate([
        customAttribute('readonly-workflow-activity'),
        autoinject,
        __metadata("design:paramtypes", [Element, BindingEngine])
    ], ReadonlyWorflowActivity);
    return ReadonlyWorflowActivity;
}());
export { ReadonlyWorflowActivity };
